export default "__VITE_ASSET__DbNhlAAG__"